<p [innerHtml]="'dga-reality-check.loggedin' | translate: { elapsedMinutes: elapsedMinutes }"></p>
<div class="obg-dga-reality-check-content">
	<p>{{ "dga-reality-check.header-summary" | translate }}</p>
	<p>
		{{ "dga-reality-check.total-losses" | translate }}
		<span class="obg-dga-reality-check-value" obgSensitiveData> {{ totalLosses }}</span>
	</p>
	<p>
		{{ "dga-reality-check.total-wins" | translate }}
		<span class="obg-dga-reality-check-value" obgSensitiveData> {{ totalWins }}</span>
	</p>
</div>
